export default __webpack_public_path__ + "static/media/kindnet.73860ea6.PNG";